import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getIsFetching, getError } from '../reducers/selectors'

import {
	getFilters,
	getNotPayingPaged,
	pagination,
} from '../reducers/selectors'
import { setNotPayingFilters } from '../reducers/actions'
import { deleteService } from '../../services/reducers/actions'

import ServiceListView from '../../services/components/ServiceList'
import WithLoading from 'app/_common/containers/HOC/WithLoading'
import WithError from 'app/_common/containers/HOC/WithError'
import { actions as paginationActions } from '../reducers'

const EnhancedServiceListView = WithError(WithLoading(ServiceListView))

const NotPayingListContainer = () => {
	const dispatch = useDispatch()
	const filters = useSelector(getFilters)
	const isFetching = useSelector(getIsFetching)
	const error = useSelector(getError)
	const { page, pageSize, pageCount } = useSelector(pagination)

	const fetchData = useCallback(
		(params = {}) => {
			dispatch(
				paginationActions.requestPage({
					page: page,
					limit: pageSize,
					filters: filters,
					not_paying: true,
					...params,
				}),
			)
		},
		[page, pageSize, filters, dispatch],
	)

	useEffect(() => {
		fetchData()
	}, [fetchData])

	const handleFilterChange = (filter, column) => {
		const newFilters = { ...filters, [column]: filter }
		dispatch(setNotPayingFilters(newFilters))
	}
	const services = useSelector(getNotPayingPaged)

	return (
		<EnhancedServiceListView
			services={services}
			isLoading={isFetching}
			error={error}
			page={page}
			pageSize={pageSize}
			pageCount={pageCount}
			onPageChange={(page) =>
				dispatch(paginationActions.setCurrentPage(page))
			}
			onPageSizeChange={(size) =>
				dispatch(paginationActions.setPageSize(size))
			}
			handleDelete={(id) => dispatch(deleteService(id))}
			onFilterChange={handleFilterChange}
			filters={filters}
		/>
	)
}

NotPayingListContainer.propTypes = {}

export default NotPayingListContainer
